import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { format } from 'date-fns';
import { faCalendar } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';

export const JoinedAt = ({
  createdAt,
  loading,
  className,
}: {
  createdAt: string;
  loading?: boolean;
  className?: string;
}) => {
  return (
    <div className="flex  items-center gap-1.5 whitespace-nowrap font-base text-base-m font-medium text-base400">
      <FontAwesomeIcon icon={faCalendar} />
      {loading ? (
        <div className="h-[18px] w-[88px] animate-pulse rounded-md bg-neutral200" />
      ) : (
        <p className={className}>Joined {format(new Date(createdAt), 'MMM yyyy')}</p>
      )}
    </div>
  );
};
